import styled from 'styled-components';

const getQScoreColor = score => {
  switch (true) {
    case score >= 6:
      return 'weak';
    case score >= 4:
      return 'moderate';
    case score >= 1:
      return 'strong';
    default:
      return 'unavailable';
  }
};

const qScore = {
  strong: '#02AD42',
  moderate: '#FCC404',
  weak: '#EE0010',
  unavailable: '#71717A'
};

export const Flex = styled.div`
  display: flex;
`;

export const DialInner = styled(Flex)`
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 0.5rem;
`;

export const DialText = styled.span`
  font-size: 1.5rem;
  font-weight: 700;
`;

export const Circle = styled.div`
  z-index: 1;
  position: absolute;
  border-radius: 50%;
  top: calc(50% - 90px);
  left: calc(50% - 90px);
  border: 90px solid white;
`;

export const DialWrapper = styled.div`
  width: 12.5rem;
  height: 12.5rem;
  position: relative;
  border-radius: 50%;
  background: ${({ score }) => {
    switch (true) {
      case score >= 1 && score <= 3.9:
        return `conic-gradient(
          #71717A 0deg 2deg,
          #02AD42 2deg calc(135deg - ((${score} - 1) * 10)*4.5deg),
          #4EC87A calc(135deg - ((${score} - 1) * 10)*4.5deg) 180deg,
          #EE0010 225deg 291deg,
          #71717A 291deg 293deg,
          #FCC404 293deg 360deg
        )`;
      case score >= 4 && +score < 6:
        return `conic-gradient(
          #71717A 0deg 2deg,
          #4EC87A 2deg 180deg,
          #EE0010 225deg 291deg,
          #71717A 291deg 293deg,
          #FCC404 293deg calc(360deg - ((${score} - 3.9) * 10)*3.35deg),
          #4EC87A calc(360deg - ((${score} - 3.9) * 10)*3.35deg) 360deg
        )`;
      case score >= 6:
        return `conic-gradient(
          #71717A 0deg 2deg,
          #4EC87A 2deg 180deg,
          #EE0010 225deg calc(360deg - ((${score} - 3.9) * 10)*3.35deg),
          #4EC87A calc(360deg - ((${score} - 3.9) * 10)*3.35deg) 291deg,
          #71717A 291deg 293deg,
          #4EC87A 293deg 360deg
        )`;
      default:
        return `conic-gradient(
          #F4F4F5 0deg 2deg,
          #D4D4D8 2deg 180deg,
          #D4D4D8 225deg 291deg,
          #F4F4F5 291deg 293deg,
          #D4D4D8 293deg 360deg
        )`;
    }
  }};
`;

export const DialArm = styled.div`
  left: 0;
  right: 0;
  z-index: 1;
  height: 100%;
  margin: 0 auto;
  position: absolute;
  width: 0.25rem;
  transform: ${({ score }) => {
    switch (true) {
      case score === 1:
        return `rotate(135deg)`;
      case score > 1 && score < 3.9:
        return `rotate(calc(135deg - (((${score} - 1) * 10) * 4.5deg)))`;
      case score === 3.9:
        return `rotate(0deg)`;
      default:
        return `rotate(calc( ((${score} - 3.9) * 10) * -3.5deg))`;
    }
  }}}

  &:before{
    top: 20px;
    height: 9.25rem;
    content: "\u25b2";
    position: absolute;
    width: 0.25rem;
    color: #18181C;
  }
  &:after{
    top: -10px;
    left: -10px;
    display: flex;
    width: 1.875rem;
    font-size: 10px;
    height: 1.875rem;
    content: "\u25CF";
    position: absolute;
    text-align: center;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    background: #F4F4F5;
    border: 4px solid ${({ score }) => qScore[getQScoreColor(score)]};
    color: ${({ score }) => qScore[getQScoreColor(score)]};
  }
`;

export const DialScore = styled(DialText)`
  color: ${({ score }) => {
    switch (true) {
      case score >= 6 && +score < 8:
        return qScore.weak;
      case score >= 4 && +score < 6:
        return qScore.moderate;
      case score >= 1 && +score < 4:
        return qScore.strong;
      default:
        return qScore.unavailable;
    }
  }};
`;

export const InnerSmallCircle = styled.div`
  display: flex;
  width: 6.25rem;
  height: 6.25rem;
  border-radius: 50%;
  align-items: center;
  shape-outside: circle();
  justify-content: center;
  border: 1px solid #e4e4e7;
`;

export const SmallCircle = styled.div`
  z-index: 1;
  display: flex;
  width: 7.5rem;
  height: 7.5rem;
  border-radius: 50%;
  position: absolute;
  align-items: center;
  justify-content: center;
  left: calc(50% - 3.75rem);
  bottom: calc(50% - 3.75rem);
  background: white;
  box-shadow: 0px 0px 35px 0px #d4d4d8;
`;

export const Triangle = styled.div`
  width: 0;
  height: 0;
  bottom: 0;
  position: absolute;
  left: calc(50% - 6.25rem);
  border-left: 6.25rem solid transparent;
  border-right: 6.25rem solid transparent;
  border-bottom: 6.25rem solid white;
`;
